import React from 'react';
import { Link } from 'react-router-dom';
import { companyProfile } from '../content/siteContent';
import { servicesData } from '../content/servicesData';

const socialLinks = [
  {
    name: 'WhatsApp',
    href: 'https://wa.me/918758637022',
    path: 'M12 5.2a6.55 6.55 0 0 0-5.66 9.86L5.5 18.8l3.84-.82A6.55 6.55 0 1 0 12 5.2Zm3.1 9.3c-.13.36-.75.67-1.03.71-.27.04-.62.07-1-.06-.23-.08-.53-.18-.92-.35-1.61-.7-2.66-2.34-2.74-2.45-.08-.11-.65-.86-.65-1.64 0-.78.41-1.16.56-1.32.15-.16.33-.2.44-.2.11 0 .22 0 .31.01.1 0 .24-.04.37.28.14.33.47 1.13.51 1.21.04.08.07.17.01.28-.05.11-.08.18-.17.27-.08.1-.18.22-.25.29-.08.08-.17.17-.07.34.1.17.44.73.95 1.18.64.57 1.17.75 1.34.83.17.08.27.07.37-.04.1-.11.4-.47.5-.63.1-.16.2-.13.34-.08.14.05.88.42 1.03.5.15.08.25.12.29.19.04.07.04.4-.09.76Z'
  },
  {
    name: 'Facebook',
    href: '#',
    path: 'M13.2 18.5v-5.6h2l.3-2.3h-2.3V9.1c0-.67.19-1.12 1.15-1.12h1.23V5.92c-.21-.03-.95-.09-1.8-.09-1.79 0-3.01 1.09-3.01 3.09v1.72H9v2.3h2.02v5.56h2.18Z'
  },
  {
    name: 'Instagram',
    href: '#',
    svgContent: (
      <>
        <rect x="6.2" y="6.2" width="11.6" height="11.6" rx="3"/>
        <circle cx="12" cy="12" r="2.9"/>
        <circle cx="16.1" cy="7.9" r="0.7" fill="currentColor" stroke="none"/>
      </>
    )
  },
  {
    name: 'LinkedIn',
    href: '#',
    svgContent: (
      <>
        <path d="M8.2 10.1v7.1M8.2 7.4h.01M11.2 10.1v7.1M11.2 12.9c0-1.7 1.1-2.8 2.6-2.8 1.5 0 2.2 1 2.2 2.9v4.2"/>
      </>
    )
  }
];

function Footer() {
  const quickServices = servicesData.slice(0, 6);

  return (
    <footer className="ftr">
      {/* ── Main footer body ── */}
      <div className="ftr__body">
        <div className="ftr__inner">

          {/* Column 1: Brand */}
          <div className="ftr__col ftr__col--brand">
            <Link to="/" className="ftr__logo-link">
              <img src="/logo.jpg" alt="Vedanskrix logo" className="ftr__logo" />
              <span className="ftr__brand-name">{companyProfile.brandName}</span>
            </Link>
            <p className="ftr__about">
              {companyProfile.legalName} — empowering individuals and businesses through technology, training, career support, and global guidance from Ahmedabad, Gujarat.
            </p>
            <div className="ftr__socials">
              {socialLinks.map(s => (
                <a
                  key={s.name}
                  href={s.href}
                  className="ftr__social"
                  aria-label={s.name}
                  target={s.href.startsWith('http') ? '_blank' : undefined}
                  rel={s.href.startsWith('http') ? 'noreferrer' : undefined}
                  onClick={s.href === '#' ? e => e.preventDefault() : undefined}
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    {s.svgContent ? s.svgContent : <path d={s.path}/>}
                  </svg>
                </a>
              ))}
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div className="ftr__col">
            <h3 className="ftr__col-title">Quick Links</h3>
            <ul className="ftr__links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/services">All Services</Link></li>
              <li><Link to="/our-work">Our Work</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>

          {/* Column 3: Services */}
          <div className="ftr__col">
            <h3 className="ftr__col-title">Our Services</h3>
            <ul className="ftr__links">
              {quickServices.map(s => (
                <li key={s.slug}>
                  <Link to={`/services/${s.slug}`}>{s.menuLabel}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4: Contact */}
          <div className="ftr__col">
            <h3 className="ftr__col-title">Contact Us</h3>
            <ul className="ftr__contact-list">
              <li>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true"><path d="M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 1 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>
                <span>{companyProfile.registeredAddress}</span>
              </li>
              <li>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true"><path d="M22 16.9v3a2 2 0 0 1-2.18 2A19.8 19.8 0 0 1 3.1 4.18 2 2 0 0 1 5.09 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L9.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.9Z"/></svg>
                <a href={`tel:${companyProfile.phone}`}>{companyProfile.phone}</a>
              </li>
              <li>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m2 7 10 7 10-7"/></svg>
                <a href={`mailto:${companyProfile.primaryEmail}`}>{companyProfile.primaryEmail}</a>
              </li>
            </ul>
            <Link to="/contact" className="ftr__contact-btn">Get In Touch</Link>
          </div>

        </div>
      </div>

      {/* ── Bottom bar ── */}
      <div className="ftr__bottom">
        <div className="ftr__bottom-inner">
          <span>© {new Date().getFullYear()} {companyProfile.legalName}. All rights reserved.</span>
          <span className="ftr__bottom-sep">|</span>
          <span>Designed &amp; Developed by Vedanskrix</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
